// ======================================================================
// File Name       : ContentQuestionEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Button, Col, Form } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import ContentQuestionEditSingleHeader from '../../components/content/ContentQuestionEditSingleHeader';
import ContentQuestionEditSingleFooter from '../../components/content/ContentQuestionEditSingleFooter';
import ContentQuestionEditSelectType from '../../components/content/ContentQuestionEditSelectType';
import ContentQuestionEditDescriptionType from '../../components/content/ContentQuestionEditDescriptionType';
import ContentQuestionEditBigHeader from '../../components/content/ContentQuestionEditBigHeader';
import ContentQuestionEditBigFooter from '../../components/content/ContentQuestionEditBigFooter';
import ContentSubQuestionDialog from '../../components/content/ContentSubQuestionDialog';
import ContentSubQuestionList from '../../components/content/ContentSubQuestionList';
import ContentQuestionAddAnswerDialog from '../../components/content/ContentQuestionAddAnswerDialog';
import ContentSingleQuestionAnswerList from '../../components/content/ContentSingleQuestionAnswerList';
import ContentBigQuestionConfirmDialog from '../../components/content/ContentBigQuestionConfirmDialog';
import ContentSingleQuestionConfirmDialog from '../../components/content/ContentSingleQuestionConfirmDialog';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import {
  CONTENT_QUESTION,
  CONTENT_QUESTION_LIST,
  CONTENT_QUESTION_DETAIL,
} from '../../constants/PathConstants';
import {
  DATA_AFFIILIATION_TYPE,
  CONTENT_QUESTION_KIND,
  ANSWER_FORMULA_NUM,
  ANSWER_FORMULA,
  INPUT_LIMIT_LONG_ANSWER_DEFAULT,
} from '../../constants/ContentConstant';
import { sortAnswerByCorrectNumbers } from '../../utils/ContentQuestionUtils';
import Header from '../../components/Header';
import { parseSelectiveAnswer, parseDecriptiveAnswer } from '../../utils/ContentUtils';
import { htmlEntities, escapeHtml } from '../../utils/index';

class ContentQuestionEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      showSingleConfirmDialog: false,
      showBigConfirmDialog: false,
      showSingleModal: false,
      showBigModal: false,
      openOrCloseSetting: false,
      selectAnswerFormula: true,
      questionInfo: {
        questionSecernId: '',
        questionKind: 0,
        questionTitle: '',
        questionAttributeScope: '',
        answerFormula: '0',
        sankakuUseDistinct: 0,
        absolutePoint: 0,
        limitTime: 0,
        hintUse: 0,
        hintHtmlUse: 0,
        hintContent: '',
        hintZipFileName: '',
        questionUseForm: 0,
        questionViewDirection: 0,
        questionContent: '',
        questionZipFileName: '',
        optionMarkKind: 0,
        optionRandomUse: '0',
        correctNumber: 0,
        correctAnswer: '',
        inputLimitType: 0,
        inputLimit: 0,
        optionArray: [],
        subQuestionArray: [],
        explanationUse: 0,
        explanationHtmlUse: 0,
        explanationContent: '',
        explanationZipFileName: '',
        explanationZipFile: '',
        hintZipFile: '',
        questionZipFile: '',
      },
      answerInfo: [],
      answer: {
        index: null,
        answerChoice: '',
        isCorrectAnswer: false,
        correctAnswer: '',
        correctAnswerNumber: '',
        subAnswer: [],
      },
      subQuestionTemplate: {
        subQuestionIndex: '',
        subQuestionSecernId: '',
        subAbsolutePoint: '',
        subAnswerFormula: '0',
      },
      redirectToDetail: false,
      isGetDataFirstTime: true,
    };
    this.onDialogCancel = this.onDialogCancel.bind(this);
    this.onConfirmDialogCancel = this.onConfirmDialogCancel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOpenOrCloseSetting = this.handleOpenOrCloseSetting.bind(this);
    this.handelShowDialog = this.handelShowDialog.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.updateSubQuestionTemplate = this.updateSubQuestionTemplate.bind(this);
    this.handleAddSubQuestion = this.handleAddSubQuestion.bind(this);
    this.openEditSubQuestionDialog = this.openEditSubQuestionDialog.bind(this);
    this.removeSubQuestion = this.removeSubQuestion.bind(this);
    this.answerChange = this.answerChange.bind(this);
    this.removeAnswer = this.removeAnswer.bind(this);
    this.handelOkAddAnswerDlg = this.handelOkAddAnswerDlg.bind(this);
    this.handleShowAddAnswerDlg = this.handleShowAddAnswerDlg.bind(this);
    this.handleAddSubAnswer = this.handleAddSubAnswer.bind(this);
    this.onSubAnswerChange = this.onSubAnswerChange.bind(this);
    this.handleOkBtnClick = this.handleOkBtnClick.bind(this);
    this.handleOkSingleConfirmDlg = this.handleOkSingleConfirmDlg.bind(this);
    this.handleOkBigConfirmDlg = this.handleOkBigConfirmDlg.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.validation = this.validation.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goBackToList = this.goBackToList.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getQuestionDetail(match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { questionInfo } = nextProps;
    const { redirectToDetail } = nextProps;
    let { isGetDataFirstTime } = this.state;
    if (questionInfo && isGetDataFirstTime) {
      this.setDataAnswerInfo(questionInfo);
      isGetDataFirstTime = !isGetDataFirstTime;
    }
    this.setState({ redirectToDetail, isGetDataFirstTime });
    if (!questionInfo.inputLimitType) {
      questionInfo.inputLimit = null;
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  goBackToList() {
    this.props.history.push(CONTENT_QUESTION_LIST);
  }

  setDataSingleQuestion(questionInfo) {
    const { optionArray, correctAnswer, correctNumber } = questionInfo;
    let { answerFormula } = questionInfo;
    let answerInfo = [];
    answerFormula = parseInt(answerFormula, 10);
    switch (answerFormula) {
      case ANSWER_FORMULA_NUM.SELECTIVE_SINGLE_ANSWER:
      case ANSWER_FORMULA_NUM.SELECTIVE_MULTIPLE_ANSWER:
        if (optionArray && optionArray.length) {
          answerInfo = parseSelectiveAnswer(optionArray, correctNumber, false);
        }
        break;
      case ANSWER_FORMULA_NUM.SELECTIVE_SORT_ANSWER:
        if (optionArray && optionArray.length) {
          answerInfo = parseSelectiveAnswer(optionArray, correctNumber, true);
        }
        break;
      case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER:
      case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER:
        if (correctAnswer) {
          answerInfo = parseDecriptiveAnswer(
            correctAnswer,
            false,
            false,
            '/',
          );
        }
        break;
      case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT:
      case ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER:
        if (correctAnswer) {
          answerInfo = parseDecriptiveAnswer(
            correctAnswer,
            true,
            false,
            '__',
          );
        }
        break;
      case ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER:
        if (correctAnswer) {
          answerInfo = parseDecriptiveAnswer(
            correctAnswer,
            true,
            true,
            '__',
          );
        }
        break;
      default:
        break;
    }
    let selectAnswerFormula = true;
    if (answerFormula >= ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER) {
      selectAnswerFormula = false;
    }
    this.setState({
      questionInfo,
      answerInfo,
      selectAnswerFormula,
    });
  }

  setDataBigQuestion(questionInfo) {
    this.setState({
      questionInfo,
    });
  }

  setDataAnswerInfo(questionInfo) {
    const { questionKind } = questionInfo;
    if (questionKind === 0) {
      this.setDataSingleQuestion(questionInfo);
    } else {
      this.setDataBigQuestion(questionInfo);
    }
  }

  getQuestionDetail(questionId) {
    if (questionId) {
      this.props.dispatch(ContentQuestionAction.getQuestionDetail(questionId));
    }
  }

  handleInputChange(name, value) {
    let { selectAnswerFormula, questionInfo } = { ...this.state };
    questionInfo = { ...this.state.questionInfo, ...{ [name]: value } };
    if (name === 'answerFormula') {
      value = parseInt(value, 10);
      if (value >= ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER) {
        if (value === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER) {
          questionInfo.inputLimitType = 1;
          questionInfo.inputLimit = questionInfo.inputLimit ? questionInfo.inputLimit : INPUT_LIMIT_LONG_ANSWER_DEFAULT;
        }
        selectAnswerFormula = false;
      } else {
        selectAnswerFormula = true;
      }
      this.setDataAnswerInfo(questionInfo);
    }
    this.setState({
      questionInfo,
      selectAnswerFormula,
    });
  }

  handleCheckBoxChange(event) {
    const { name, value } = event.target;
    let { questionInfo } = { ...this.state };
    if (
      name === 'optionRandomUse' ||
      name === 'sankakuUseDistinct' ||
      name === 'explanationUse' ||
      name === 'hintUse' ||
      name === 'inputLimitType'
    ) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    }
    if (name === 'inputLimitType' && event.target.checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: event.target.checked ? 1 : 0 },
        ...{ inputLimit: '' },
      };
      // Hide error message
      if (this.refsToValidate && this.refsToValidate.length) {
        this.refsToValidate.forEach((item) => {
          if (item.constructor.name === 'ContentQuestionEditDescriptionType') {
            item.refsToValidate.forEach((item) => {
              if (item.props.name === 'inputLimit') {
                item.setState({ errorVisible: false });
              }
            });
          }
        });
      }
    }
    if (name === 'explanationUse' && event.target.checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: event.target.checked ? 1 : 0 },
        ...{ explanationContent: '' },
        ...{ explanationHtmlUse: '0' },
        ...{ explanationZipFile: '' },
        ...{ explanationZipFileName: '' },
      };
    }
    if (name === 'hintUse' && event.target.checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: event.target.checked },
        ...{ hintContent: '' },
        ...{ hintHtmlUse: '0' },
        ...{ hintZipFile: '' },
        ...{ hintZipFileName: '' },
      };
    }
    this.setState({ questionInfo });
  }

  updateSubQuestionTemplate(subQuestionDetail) {
    const lastTemplate = this.state.subQuestionTemplate;
    if (subQuestionDetail) {
      lastTemplate.subQuestionIndex = subQuestionDetail.subQuestionIndex;
      lastTemplate.subQuestionSecernId = subQuestionDetail.subQuestionSecernId;
      lastTemplate.subAbsolutePoint = subQuestionDetail.subAbsolutePoint;
      lastTemplate.subAnswerFormula = subQuestionDetail.subAnswerFormula;
    } else {
      lastTemplate.subQuestionIndex = null;
      lastTemplate.subQuestionSecernId = '';
      lastTemplate.subAbsolutePoint = '';
      lastTemplate.subAnswerFormula = '0';
    }

    this.setState({
      subQuestionTemplate: lastTemplate,
    });
  }

  handleOpenOrCloseSetting() {
    let { openOrCloseSetting } = { ...this.state };
    openOrCloseSetting = !openOrCloseSetting;
    this.setState({
      openOrCloseSetting,
    });
  }

  handleFileChange(event) {
    if (event.target.files.length !== 0) {
      const { id } = event.target;
      let { questionInfo } = this.state;
      if (id === 'questionZipFileName') {
        const questionZipFileName = event.target.files[0].name;
        questionInfo = {
          ...this.state.questionInfo,
          ...{ questionZipFile: event.target.files[0], questionZipFileName },
        };
      } else if (id === 'explanationZipFileName') {
        const explanationZipFileName = event.target.files[0].name;
        questionInfo = {
          ...this.state.questionInfo,
          ...{ explanationZipFile: event.target.files[0], explanationZipFileName },
        };
      } else if (id === 'hintZipFileName') {
        const hintZipFileName = event.target.files[0].name;
        questionInfo = {
          ...this.state.questionInfo,
          ...{ hintZipFile: event.target.files[0], hintZipFileName },
        };
      }

      this.setState({
        questionInfo,
      });
    }
  }

  handleShowAddAnswerDlg(index) {
    const { answerInfo, selectAnswerFormula } = this.state;
    let { questionInfo } = this.state;
    const { answerFormula } = questionInfo;
    let answer = {
      index: null,
      answerChoice: '',
      isCorrectAnswer: false,
      correctAnswer: '',
      correctAnswerNumber: '',
      subAnswer: [],
    };
    if (index !== null) {
      answer = $.extend(true, {}, answerInfo[index]);
      answer.index = index;
    }
    questionInfo = {
      ...this.state.questionInfo,
    };
    this.setState({
      questionInfo,
      showSingleModal: true,
      answer,
    });
  }

  handleOkBtnClick() {
    const { questionInfo } = this.state;
    const { questionKind } = questionInfo;
    if (this.validation()) {
      if (questionKind == 0) {
        this.handleOkSingleConfirmDlg(true);
      } else {
        this.handleOkBigConfirmDlg(true);
      }
    }
  }
  handelShowDialog() {
    let { questionInfo, selectAnswerFormula } = this.state;
    const { questionKind, answerFormula } = questionInfo;
    if (questionKind == 0) {
      const answer = {
        index: null,
        answerChoice: '',
        isCorrectAnswer: false,
        correctAnswer: '',
        correctAnswerNumber: '',
        subAnswer: [],
      };
      questionInfo = {
        ...this.state.questionInfo,
      };
      this.setState({ showSingleModal: true, questionInfo, answer });
    } else {
      this.setState({ showBigModal: true });
    }
  }

  handelAddSubQuestionShowDialog() {
    this.updateSubQuestionTemplate(null);
    this.setState({ showBigModal: true });
  }

  openEditSubQuestionDialog(subQuestionDetail) {
    this.updateSubQuestionTemplate(subQuestionDetail);
    this.handelShowDialog();
  }

  parseDataToInt(subQuestion) {
    if (subQuestion) {
      if (subQuestion.subQuestionIndex) {
        subQuestion.subQuestionIndex = parseInt(subQuestion.subQuestionIndex, 10);
      }
      if (subQuestion.subAbsolutePoint) {
        subQuestion.subAbsolutePoint = parseInt(subQuestion.subAbsolutePoint, 10);
      }
    }
    return subQuestion;
  }

  handleAddSubQuestion(subQuestion) {
    const lastSubList = this.state.questionInfo.subQuestionArray;
    if (
      subQuestion.subQuestionIndex !== undefined &&
      subQuestion.subQuestionIndex !== null &&
      subQuestion.subQuestionIndex !== ''
    ) {
      lastSubList[subQuestion.subQuestionIndex] = this.parseDataToInt(subQuestion);
    } else {
      subQuestion.subQuestionIndex = lastSubList.length;
      lastSubList.push(this.parseDataToInt(subQuestion));
    }
    const questionInfo = {
      ...this.state.questionInfo,
      ...{ subQuestionArray: lastSubList },
    };
    this.setState({
      questionInfo,
      showBigModal: false,
    });
  }

  handelOkAddAnswerDlg(index) {
    const { answer } = this.state;
    const { answerInfo } = this.state;
    if (answer && answer.subAnswer && answer.subAnswer.length) {
      let subAnswer = answer.subAnswer;
      subAnswer = subAnswer.filter(sub => !!sub);
      answer.subAnswer = subAnswer;
    }
    if (index == null) {
      answerInfo.push(answer);
    } else {
      answerInfo[index] = this.state.answer;
    }
    this.setState({ ...this.state, answerInfo, showSingleModal: false });
  }

  answerChange(event) {
    const { name, value } = event.target;
    let { answer } = this.state.answer;
    if (name === 'answerChoice' || name === 'correctAnswerNumber' || name === 'correctAnswer') {
      answer = { ...this.state.answer, ...{ [name]: value } };
    } else if (name === 'isCorrectAnswer') {
      answer = {
        ...this.state.answer,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    }
    this.setState({
      answer,
    });
  }

  removeAnswer(index) {
    const { answerInfo } = this.state;
    answerInfo.splice(index, 1);
    this.setState({ ...this.state, answerInfo });
  }

  handleAddSubAnswer() {
    this.setState(prevState => ({
      ...prevState.answer.subAnswer.push(''),
    }));
  }

  onSubAnswerChange(index, event) {
    const { subAnswer } = this.state.answer;
    const { value } = event.target;
    subAnswer[index] = value;
    this.setState({ ...this.state.answer, subAnswer });
  }

  removeSubQuestion(subQuestionIndex) {
    let { questionInfo } = this.state;
    const { subQuestionArray } = questionInfo;
    subQuestionArray.splice(subQuestionIndex, 1);
    questionInfo = {
      ...this.state.questionInfo,
      ...{ subQuestionArray },
    };
    this.setState({
      questionInfo,
    });
  }

  onDialogCancel() {
    this.setState({ showDeleteModal: false });
    this.setState({ showSingleModal: false });
    this.setState({ showBigModal: false });
    this.setState({ showBigConfirmDialog: false });
    this.setState({ showSingleConfirmDialog: false });
  }

  onConfirmDialogCancel() {
    this.setState({ showSingleConfirmDialog: false, questionDetail: {} });
  }

  handleOkSingleConfirmDlg(isDialogDetail) {
    const { questionInfo } = this.state;
    const optionArray = [];
    questionInfo.optionArray = [];
    questionInfo.correctAnswer = '';
    questionInfo.correctNumber = '';
    questionInfo.answerFormula = questionInfo.answerFormula || ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER;
    const questionAnswerFormula = questionInfo.answerFormula.toString();
    const selectiveCorrectAnswerSortList = {};
    let answerInfo = $.extend(true, [], this.state.answerInfo);
    if (isDialogDetail !== true &&
        questionAnswerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) {
      answerInfo = sortAnswerByCorrectNumbers(answerInfo);
    }
    for (const key in answerInfo) {
      const answer = answerInfo[key];
      if (answer) {
        const obj = {
          optionNumber: parseInt(key, 10) + 1,
          optionContent: '',
        };
        obj.optionContent = answer.answerChoice;
        if (answer.correctAnswer) {
          obj.optionContent = answer.correctAnswer;
        }
        if (answer.isCorrectAnswer) {
          questionInfo.correctNumber += `_${parseInt(key, 10) + 1}`;
        }
        if (answer.correctAnswerNumber) {
          questionInfo.correctNumber += `_${answer.correctAnswerNumber}`;
          // Create selectiveCorrectAnswerSortList
          const correctAnswerNumber = !isNaN(answer.correctAnswerNumber) ?
          parseInt(answer.correctAnswerNumber, 10) : null;
          if (correctAnswerNumber !== null) {
            selectiveCorrectAnswerSortList[correctAnswerNumber] = parseInt(key, 10) + 1;
          }
        }

        if (answer.subAnswer.length > 0) {
          obj.optionContent += `/${answer.subAnswer.join('/')}`;
        }
        optionArray.push(obj);
        if (parseInt(questionInfo.answerFormula, 10) > 2) {
          questionInfo.correctAnswer += `__${obj.optionContent}`;
        }
      }
    }
    // Handle CorrectNum for selectiveCorrectAnswer
    if (questionAnswerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER) {
      questionInfo.correctNumber = '';
      if (selectiveCorrectAnswerSortList) {
        $.each(selectiveCorrectAnswerSortList, (index, value) => {
          questionInfo.correctNumber += `_${value}`;
        });
      }
    }
    questionInfo.optionArray = optionArray;
    questionInfo.correctAnswer = questionInfo.correctAnswer ?
    questionInfo.correctAnswer.substring(2) : '';
    questionInfo.correctNumber = questionInfo.correctNumber ?
    questionInfo.correctNumber.substring(1) : '';
    // set question info
    questionInfo.questionUseForm = parseInt(questionInfo.questionUseForm, 10);
    if (questionInfo.questionUseForm) {
      questionInfo.questionZipFile = questionInfo.questionZipFile ?
      questionInfo.questionZipFile : null;
    } else {
      questionInfo.questionZipFile = null;
    }
    // set explanation info
    questionInfo.explanationUse = parseInt(questionInfo.explanationUse, 10);
    questionInfo.explanationHtmlUse = parseInt(questionInfo.explanationHtmlUse, 10);
    if (questionInfo.explanationUse && questionInfo.explanationHtmlUse) {
      questionInfo.explanationZipFile = questionInfo.explanationZipFile ?
      questionInfo.explanationZipFile : null;
    } else {
      questionInfo.explanationHtmlUse = 0;
    }
    // set hint info
    questionInfo.hintUse = parseInt(questionInfo.hintUse, 10);
    questionInfo.hintHtmlUse = parseInt(questionInfo.hintHtmlUse, 10);
    if (questionInfo.hintUse && questionInfo.hintHtmlUse) {
      questionInfo.hintZipFile = questionInfo.hintZipFile ? questionInfo.hintZipFile : null;
    } else {
      questionInfo.hintHtmlUse = 0;
    }
    if (isDialogDetail === true) {
      this.setState({
        showSingleConfirmDialog: true,
        questionDetail: { ...questionInfo },
      });
    } else {
      this.setState(
        {
          showSingleConfirmDialog: false,
        },
        () => {
          // If answerFormula >= 3 and answerFormula < 7 and contain newline in correct answer content
          // replace all newline tags to empty string
          if (questionInfo.answerFormula >= ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER &&
            questionInfo.answerFormula < ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER) {
            if (questionInfo.correctAnswer && questionInfo.correctAnswer.length) {
              const correctAnswer = questionInfo.correctAnswer;
              const convertCorrectAnswer = String(correctAnswer).replace(/[\r\n]/mg, '');
              questionInfo.correctAnswer = convertCorrectAnswer;
            }
          }
          this.props.dispatch(ContentQuestionAction.updateQuestionSingle(questionInfo));
        },
      );
    }
  }

  handleOkBigConfirmDlg(isDialogDetail) {
    const { questionInfo } = this.state;
    if (questionInfo.subQuestionArray) {
      for (const key in questionInfo.subQuestionArray) {
        questionInfo.subQuestionArray[key].subQuestionIndex = parseInt(key, 10) + 1;
      }
    }
    // set explanation info
    questionInfo.explanationUse = parseInt(questionInfo.explanationUse, 10);
    questionInfo.explanationHtmlUse = parseInt(questionInfo.explanationHtmlUse, 10);
    if (questionInfo.explanationUse && questionInfo.explanationHtmlUse) {
      questionInfo.explanationZipFile = questionInfo.explanationZipFile ?
      questionInfo.explanationZipFile : null;
    } else {
      questionInfo.explanationHtmlUse = 0;
    }
    // set hint info
    questionInfo.hintUse = parseInt(questionInfo.hintUse, 10);
    questionInfo.hintHtmlUse = parseInt(questionInfo.hintHtmlUse, 10);
    if (questionInfo.hintUse && questionInfo.hintHtmlUse) {
      questionInfo.hintZipFile = questionInfo.hintZipFile ? questionInfo.hintZipFile : null;
    } else {
      questionInfo.hintHtmlUse = 0;
    }
    if (isDialogDetail === true) {
      this.setState({
        showBigConfirmDialog: true,
        questionInfo: { ...questionInfo },
      });
    } else {
      this.setState(
        {
          showBigConfirmDialog: false,
        },
        () => {
          this.props.dispatch(ContentQuestionAction.updateQuestionBig(questionInfo));
        },
      );
    }
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  parseDataForRadioCheckBox(obj) {
    let {
      inputLimitType,
      optionRandomUse,
      questionUseForm,
      explanationUse,
      explanationHtmlUse,
      hintUse,
      hintHtmlUse,
      questionViewDirection,
      sankakuUseDistinct,
    } = obj;
    if (!this.isNullOrUndefined(questionUseForm)) {
      questionUseForm = questionUseForm.toString();
    } else {
      // set default value for questionUseForm
      questionUseForm = '0';
    }
    if (!this.isNullOrUndefined(hintHtmlUse)) {
      hintHtmlUse = hintHtmlUse.toString();
    } else {
      // set default value for hintHtmlUse
      hintHtmlUse = '0';
    }
    if (!this.isNullOrUndefined(explanationHtmlUse)) {
      explanationHtmlUse = explanationHtmlUse.toString();
    } else {
      // set default value for explanationHtmlUse
      explanationHtmlUse = '0';
    }
    if (!this.isNullOrUndefined(questionViewDirection)) {
      questionViewDirection = questionViewDirection.toString();
    }
    inputLimitType = !!inputLimitType;
    optionRandomUse = !!optionRandomUse;
    explanationUse = !!explanationUse;
    hintUse = !!hintUse;
    sankakuUseDistinct = !!sankakuUseDistinct;
    return {
      inputLimitType,
      optionRandomUse,
      questionUseForm,
      explanationUse,
      explanationHtmlUse,
      hintUse,
      hintHtmlUse,
      questionViewDirection,
      sankakuUseDistinct,
    };
  }

  isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
  }

  render() {
    const {
      questionInfo,
      openOrCloseSetting,
      selectAnswerFormula,
      answer,
      answerInfo,
      redirectToDetail,
    } = this.state;
    const {
      questionKind,
      questionSecernId,
      questionTitle,
      questionContent,
      answerFormula,
      optionMarkKind,
      correctAnswer,
      correctNumber,
      optionArray,
      subQuestionArray,
      absolutePoint,
      limitTime,
      explanationContent,
      explanationZipFileName,
      hintContent,
      questionZipFileName,
      hintZipFileName,
      inputLimit,
      questionAttributeList,
    } = questionInfo;
    const {
      inputLimitType,
      optionRandomUse,
      questionUseForm,
      explanationUse,
      explanationHtmlUse,
      hintUse,
      hintHtmlUse,
      questionViewDirection,
      sankakuUseDistinct,
    } = this.parseDataForRadioCheckBox(questionInfo);
    const questionTitleTemp = questionTitle ? htmlEntities(questionTitle) : ''; // #6818
    const questionContentTemp = questionContent ? htmlEntities(questionContent) : '';
    this.refsToValidate = [];
    const answerFormulaStr = answerFormula ? answerFormula.toString() : '0';
    const isQuestionUseForm = questionUseForm === '1';
    if (redirectToDetail) {
      this.goBackToList();
    }
    let questionTypeTemplate = null;
    let questionEditFooter = null;
    let questionEditHeader = null;
    let questionEditList = null;
    let contentSubQuestionList = null;
    if (questionKind == 0) {
      if (selectAnswerFormula) {
        questionTypeTemplate = (
          <ContentQuestionEditSelectType
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            answerFormula={answerFormula}
            optionMarkKind={optionMarkKind || ''}
            optionRandomUse={optionRandomUse}
            onInputChange={this.handleInputChange}
            answerInfo={answerInfo}
            onCheckBoxChange={this.handleCheckBoxChange}
            onShowDialogBtnClick={this.handelShowDialog.bind(this, answerFormula)}
            questionUseForm={questionUseForm}
          />
        );
      } else {
        questionTypeTemplate = (
          <ContentQuestionEditDescriptionType
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            answerFormula={answerFormula}
            optionRandomUse={optionRandomUse}
            onInputChange={this.handleInputChange}
            inputLimit={inputLimit}
            inputLimitType={inputLimitType}
            answerInfo={answerInfo}
            onCheckBoxChange={this.handleCheckBoxChange}
            onShowDialogBtnClick={this.handelShowDialog.bind(this, answerFormula)}
            questionUseForm={questionUseForm}
          />
        );
      }
      questionEditFooter = (
        <ContentQuestionEditSingleFooter
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          questionUseForm={questionUseForm}
          onInputChange={this.handleInputChange}
          absolutePoint={absolutePoint}
          questionViewDirection={questionViewDirection}
          sankakuUseDistinct={sankakuUseDistinct}
          explanationUse={explanationUse}
          explanationHtmlUse={explanationHtmlUse}
          explanationContent={explanationContent}
          explanationZipFileName={explanationZipFileName}
          hintUse={hintUse}
          hintContent={hintContent}
          hintHtmlUse={hintHtmlUse}
          hintZipFileName={hintZipFileName}
          limitTime={limitTime}
          questionAttributeList={questionAttributeList}
          onOpenOrCloseSetting={this.handleOpenOrCloseSetting}
          openOrCloseSetting={openOrCloseSetting}
          onFileChange={this.handleFileChange}
          onOkBtnClick={this.handleOkBtnClick}
          onCheckBoxChange={this.handleCheckBoxChange}
          goBackToDetail={this.goBack}
        />
      );
      questionEditHeader = (
        <ContentQuestionEditSingleHeader
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          questionKind={questionKind}
          questionSecernId={questionSecernId}
          questionTitle={questionTitleTemp} // #6818
          questionContent={questionContentTemp}
          questionUseForm={questionUseForm}
          answerFormula={answerFormula}
          selectAnswerFormula={selectAnswerFormula}
          questionZipFileName={questionZipFileName}
          onInputChange={this.handleInputChange}
          onFileChange={this.handleFileChange}
        />
      );
      if (answerFormulaStr) {
        questionEditList = (
          <ContentSingleQuestionAnswerList
            answerInfo={answerInfo}
            answerFormula={answerFormulaStr}
            removeAnswer={this.removeAnswer}
            showAddAnswerDlg={this.handleShowAddAnswerDlg}
          />
        );
      }
    } else {
      questionEditFooter = (
        <ContentQuestionEditBigFooter
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          onInputChange={this.handleInputChange}
          sankakuUseDistinct={sankakuUseDistinct}
          explanationUse={explanationUse}
          explanationHtmlUse={explanationHtmlUse}
          explanationContent={explanationContent}
          explanationZipFileName={explanationZipFileName}
          hintUse={hintUse}
          hintContent={hintContent}
          hintHtmlUse={hintHtmlUse}
          hintZipFileName={hintZipFileName}
          limitTime={limitTime}
          questionAttributeList={questionAttributeList}
          onOpenOrCloseSetting={this.handleOpenOrCloseSetting}
          onCheckBoxChange={this.handleCheckBoxChange}
          openOrCloseSetting={openOrCloseSetting}
          onFileChange={this.handleFileChange}
          onOkBtnClick={this.handleOkBtnClick}
          goBackToDetail={this.goBack}
        />
      );
      contentSubQuestionList = (
        <ContentSubQuestionList
          subQuestionArray={subQuestionArray}
          handleRemoveSubQuestion={this.removeSubQuestion}
          openEditSubQuestionDialog={this.openEditSubQuestionDialog}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
      questionEditHeader = (
        <ContentQuestionEditBigHeader
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          questionKind={questionKind}
          questionSecernId={questionSecernId}
          questionTitle={questionTitleTemp} // #6818
          onInputChange={this.handleInputChange}
          onFileChange={this.handleFileChange}
          questionZipFileName={questionZipFileName}
          subQuestionArray={subQuestionArray}
          onShowDialogBtnClick={this.handelAddSubQuestionShowDialog.bind(this, answerFormula)}
        />
      );
    }
    return (
      <div>
        <Header name="問題の編集" />
        <Form className='form-horizontal'>
          {questionEditHeader}
          {!isQuestionUseForm && questionTypeTemplate}
          {!isQuestionUseForm && questionEditList}
          {isQuestionUseForm && questionKind == 1 && contentSubQuestionList}
          {questionEditFooter}
          <ContentSubQuestionDialog
            subQuestionArray={subQuestionArray}
            show={this.state.showBigModal}
            subQuestionIndex={this.state.subQuestionTemplate.subQuestionIndex}
            subQuestionSecernId={this.state.subQuestionTemplate.subQuestionSecernId}
            subAbsolutePoint={this.state.subQuestionTemplate.subAbsolutePoint}
            subAnswerFormula={this.state.subQuestionTemplate.subAnswerFormula}
            onOkClick={this.handleAddSubQuestion}
            onCancelClick={this.onDialogCancel}
            updateSubQuestionTemplate={this.updateSubQuestionTemplate}
          />
          <ContentQuestionAddAnswerDialog
            answerInfo={answerInfo}
            showModal={this.state.showSingleModal}
            answerFormula={answerFormulaStr}
            answer={answer}
            handleAnswerChange={this.answerChange}
            onOK={this.handelOkAddAnswerDlg}
            onCancel={this.onDialogCancel}
            addSubAnswer={this.handleAddSubAnswer}
            handleSubAnswerChange={this.onSubAnswerChange}
          />
          <ContentBigQuestionConfirmDialog
            {...this.state.questionInfo}
            showModal={this.state.showBigConfirmDialog}
            onOkClick={this.handleOkBigConfirmDlg}
            onCancelClick={this.onDialogCancel}
          />
          <ContentSingleQuestionConfirmDialog
            showModal={this.state.showSingleConfirmDialog}
            {...this.state.questionDetail}
            onOK={this.handleOkSingleConfirmDlg}
            onCancel={this.onConfirmDialogCancel}
            answerInfo={answerInfo}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionInfo } = state.question;
  return { ...{ questionInfo }, ...{ redirectToDetail: state.question.redirectToDetail } };
};

export default connect(mapStateToProps)(ContentQuestionEditContainer);
